// removed by extract-text-webpack-plugin
module.exports = {"product-detail":"product-detail","content-wrap":"content-wrap","left-content-detail":"left-content-detail","right-content-detail":"right-content-detail","bottom-content-detail":"bottom-content-detail","product-image-detail-container":"product-image-detail-container","product-info-container":"product-info-container","title-bottom-content":"title-bottom-content"};


//////////////////
// WEBPACK FOOTER
// ./components/product-detail/style.scss
// module id = ./components/product-detail/style.scss
// module chunks = 0